const skey = 'Zhjc11102006'

const firebaseConfig = {
  apiKey: "AIzaSyCw8j0vPKvHLFq_zo_jDqwKtg9BWtE80LE",
  authDomain: "mdtv7-52d98.firebaseapp.com",
  projectId: "mdtv7-52d98",
  storageBucket: "mdtv7-52d98.appspot.com",
  messagingSenderId: "556818045316",
  appId: "1:556818045316:web:4e77422535e5f686a625d1"
}

const actionCodeSettings = {
  url: 'https://' + firebaseConfig.authDomain + '/finishSignUp?cartId=' + generatePassword(8),
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: false,
    minimumVersion: '7'
  },
  dinamicLinkDomain: '3orirvb.page.link'
}

const redirectUrl = 'https://healtsustav.space/dgtfu'
const urlSheets = 'https://script.google.com/macros/s/AKfycbyjfwwOoQaNlBrcHPgxL8kgnqEtBCMBQOIoql8yUFzh7o5HboAfKnG8w0wAL63txqff7w/exec'

function generatePassword (l) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let retVal = ''
  for (let i = 0, n = charset.length; i < l; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

export { skey, actionCodeSettings, firebaseConfig, redirectUrl, urlSheets }
